/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTia3plSurveyControl.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/tia-3pl-survey-control";

export class AutogenModelTia3plSurveyControl<RowType extends ModelRow> extends Endpoint<RowType, RowTia3plSurveyControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTia3plSurveyControl extends ModelRow<RowTia3plSurveyControlFields> {
	constructor(values?: Partial<RowTia3plSurveyControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTia3plSurveyControlFields {
	company_id: string;
	email: string;
	end_date: Date;
	id: string;
	is_active: string;
	start_date: Date;
	survey_url: string;
	token: string;
}

